//import liraries
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize,} from "rn-responsive-styles";


// define your styles
const useStyles = CreateResponsiveStyle(
  {
    mainContainer: {
      width: "100%",
      height: "45vh",
      marginTop: 30,
      marginLeft: 20,
    },
    container: {
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff",
      borderRadius: 15,
    },
    cardContainer: {
      width: "100%",
      height: "100%",
      backgroundColor: "#ffffff",
      borderRadius: 15,
      marginTop: 10,
    },
    rowStyle: {
      width: 100,
      minWidth: 100,
      paddingHorizontal: 10,
      marginVertical: 5,
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 30,
      letterSpacing: 0,
      textAlign: "left",
      color: "#66625f",
    },
    headerTextStyle: {
      width: 100,
      height: 60,
      minWidth: 100,
      paddingHorizontal: 10,
      marginVertical: 5,
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.99,
      textAlign: "left",
      color: "#66625f",
      paddingTop: 10,
    },
    verticalLineStyle: {
      width: 0.5,
      height: "100%",
      backgroundColor: "#a0a0a0",
    },
    headerViewStyle: {
      flexDirection: "row",
      backgroundColor: "#ffffff",
      borderTopRightRadius: 10,
      borderTopLeftRadius: 10,
      borderBottomWidth: 0.5,
      borderColor: "#a0a0a0",
    },
    dataViewStyle: {
      flexDirection: "row",
    },
    topViewStyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
    },
    showEntriesViewStyle: {
      flexDirection: "row",
      alignItems: "center",
    },
    showTextStyle: {
      fontFamily: "Inter",
      fontSize: 15,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 30,
      letterSpacing: 0,
      textAlign: "left",
      color: "#ffffff",
    },
    dropDownViewStyle: {
      width: 44,
      height: 22,
      borderRadius: 4,
      borderStyle: "solid",
      borderWidth: 1,
      borderColor: "#ffffff",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginLeft: 10,
    },
    valueTextStyle: {
      fontFamily: "Inter",
      fontSize: 12,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 24,
      letterSpacing: 0,
      textAlign: "left",
      color: "#ffffff",
      paddingRight: 5,
    },
    downArrowImageStyle: {
      width: 9.5,
      height: 4.8,
      resizeMode: "contain",
    },
    secondRowStyle: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
    },
    searchTextStyle: {
      fontFamily: "Inter",
      fontSize: 13,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 17,
      letterSpacing: 0.99,
      textAlign: "left",
      color: "#ffffff",
    },
    searchTextInputStyle: {
      width: 177.1,
      height: 26.8,
      backgroundColor: "#ffffff",
      marginLeft: 10,
      marginRight: 10,
      fontFamily: "Inter",
      fontSize: 11,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: 15,
      letterSpacing: 0.84,
      textAlign: "left",
      color: "#66625f",
      paddingHorizontal: 10,
      borderRadius: 5,
    },
    searchIconContainerStyle: {
      position: "absolute",
      zIndex: 999,
      right: 20,
    },
    searchIconStyle: {
      width: 13,
      height: 12.5,
      resizeMode: "contain",
    },
  },
  {
    [DEVICE_SIZES.LG]: {
      mainContainer: {
        width: 800,
        borderRadius: 15,
      },
      container: {
        width: "97%",
      },
    },
    [DEVICE_SIZES.MD]: {
      mainContainer: {
        height: 649,
        width: "95%",
        borderRadius: 15,
      },
      container: {
        width: "97%",
      },
    },
    [DEVICE_SIZES.SM]: {
      mainContainer: {
        width: 528,
        height: 649,
        borderRadius: 15,
      },
      container: {
        width: "97%",
      },
    },
    [DEVICE_SIZES.XS]: {
      mainContainer: {
        maxWidth: 325.8,
        height: 549.5,
        borderRadius: 15,
        marginLeft:0,
        alignSelf: "center",
      },
      container: {
        width: "97%",
      },
      showTextStyle: {
        fontSize: 9,
        lineHeight: 18,
      },
      dropDownViewStyle: {
        width: 29.5,
        height: 14.7,
      },
      valueTextStyle: {
        fontSize: 6,
        lineHeight: 12,
      },
      downArrowImageStyle: {
        width: 6.4,
        height: 3.2,
      },
      searchTextStyle: {
        fontSize: 9,
        lineHeight: 13,
      },
      searchTextInputStyle: {
        width: 132.3,
        height: 17.1,
        fontSize: 8,
        lineHeight: 11,
      },
      searchIconStyle: {
        width: 10.6,
        height: 10.3,
      },
    },
  }
);

//make this component available to the app
export default useStyles;
